import { Button } from 'entities/Button'
import { SPItem, SPItemsContainer } from './styles'
import { useState } from 'react'
import { RenderIf } from 'shared/helpers/renderIf'
import StorefrontIcon from '@mui/icons-material/Storefront'
import { useBranchStore } from 'shared/store/branchesSlice'
import { CircularProgress } from '@mui/material'
import { useConfigStore } from 'shared/store/configSlice'

export const BranchList = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const loadConfig = useConfigStore().loadConfig
  const { branchList, branchId, isBranchesLoading, changeBranchId } = useBranchStore()

  const handleShippingPointClick = (spToSet: number) => {
    changeBranchId(spToSet)
    loadConfig(spToSet)
    setIsMenuOpen(false)
  }

  const toggleMenu = (newValue: boolean) => {
    if (branchList?.length > 1) {
      setIsMenuOpen(newValue)
    } else {
      setIsMenuOpen(false)
    }
  }

  return (
    <div>
      <Button
        handleClick={() => toggleMenu(!isMenuOpen)}
        width='100%'
        variant='outlined'
        color='warning'
        sx={{
          position: 'relative',
          minWidth: '200px',
          zIndex: '1000'
        }}
      >
        <RenderIf condition={!isBranchesLoading}>
          <StorefrontIcon />
          <p style={{ marginLeft: '10px' }}>
            {branchList?.find(b => b.Intern === branchId)?.Bezeichnung}
          </p>
        </RenderIf>
        <RenderIf condition={isBranchesLoading}>
          <CircularProgress color='warning' size={25} />
        </RenderIf>
      </Button>
      <RenderIf condition={isMenuOpen && branchList?.length > 1}>
        <SPItemsContainer>
          {branchList?.map((sp, i) => (
            <SPItem
              key={i}
              onClick={() => handleShippingPointClick(sp.Intern)}
              isSelected={sp.Intern === branchId}
            >
              {sp.Bezeichnung}
            </SPItem>
          ))}
        </SPItemsContainer>
      </RenderIf>
    </div>
  )
}
